import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 72 72",
  "content": "<symbol viewBox=\"0 0 72 72\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-right\">\n<circle cx=\"36\" cy=\"36\" r=\"36\" fill=\"black\" fill-opacity=\"0.3\" />\n<path d=\"M46.3584 36L36.5449 46.6768L35.0723 45.3232L42.7227 37H27V35H42.7227L35.0723 26.6768L36.5449 25.3232L46.3584 36Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol